import React, { Component } from 'react';
import { Modal, message, Button, Select, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const Option = Select.Option;

class EvaluateSiteUpdate extends Component {
    state = {
        visible: false,
        loading: false,
        isEdit: false,
        evaluateRecordSiteId: null,
        evaluateRecordId: null,
        // 选择的数据
        hospitalMainList: [],
        hospitalMainName: '',
        hospitalMainId: '',
        pendingType: '',
        courtyardAreaList: [],
        courtyardArea: '',
        // 当前选中的实际ID（根据pendingType不同，可能是hospitalId或pendingHospitalId）
        resolvedHospitalId: '',
        departmentList: [],
        departmentId: '',
        departmentSearchText: '',
        fetchingDepartment: false,
        doctorList: [],
        doctorId: '',
        doctorSearchText: '',
        fetchingDoctor: false,
        // 搜索用
        fetchingHospital: false,
        hospitalSearchText: '',
    }

    show = (record, evaluateRecordId) => {
        if (record) {
            // 修改模式
            const isCooperating = record.pendingType === 'COOPERATING';
            // 直接从记录中构造科室/医生列表，避免异步查询匹配不到导致回显异常
            const initialDeptList = [];
            const initialDoctorList = [];
            if (isCooperating) {
                if (record.hospitalDepartmentId) {
                    initialDeptList.push({ hospitalDepartmentId: record.hospitalDepartmentId, deptName: record.deptName || '' });
                }
                if (record.doctorPostId) {
                    initialDoctorList.push({ doctorPostId: record.doctorPostId, userCompellation: record.doctorName || '', doctorName: record.doctorName || '' });
                }
            } else {
                if (record.pendingHospitalDepartmentId) {
                    initialDeptList.push({ hospitalDeptPendingCooperationId: record.pendingHospitalDepartmentId, deptName: record.deptName || '' });
                }
                if (record.pendingDoctorPostId) {
                    initialDoctorList.push({ doctorPendingCooperationId: record.pendingDoctorPostId, userCompellation: record.doctorName || '', doctorName: record.doctorName || '' });
                }
            }
            this.setState({
                visible: true,
                isEdit: true,
                evaluateRecordSiteId: record.evaluateRecordSiteId,
                evaluateRecordId: record.evaluateRecordId,
                hospitalMainName: record.hospitalName || '',
                hospitalMainId: record.hospitalMainId || '',
                pendingType: record.pendingType || '',
                courtyardArea: record.courtyardArea || '',
                resolvedHospitalId: isCooperating ? (record.hospitalId || '') : (record.pendingHospitalId || ''),
                departmentId: isCooperating ? (record.hospitalDepartmentId || '') : (record.pendingHospitalDepartmentId || ''),
                doctorId: isCooperating ? (record.doctorPostId || '') : (record.pendingDoctorPostId || ''),
                // 直接用记录中的数据构造列表，保证回显正确
                courtyardAreaList: [],
                departmentList: initialDeptList,
                doctorList: initialDoctorList,
                fetchingDepartment: false,
                fetchingHospital: false,
                hospitalSearchText: record.hospitalName || '',
            }, () => {
                if (record.pendingType === 'COOPERATING') {
                    this.queryCooperatingCourtyardArea();
                } else if (record.pendingType === 'PENDING') {
                    this.queryPendingCourtyardArea();
                }
            });
        } else {
            // 新增模式
            this.setState({
                visible: true,
                isEdit: false,
                evaluateRecordSiteId: null,
                evaluateRecordId,
                hospitalMainList: [],
                hospitalMainName: '',
                hospitalMainId: '',
                pendingType: '',
                courtyardAreaList: [],
                courtyardArea: '',
                resolvedHospitalId: '',
                departmentList: [],
                departmentId: '',
                departmentSearchText: '',
                fetchingDepartment: false,
                doctorList: [],
                doctorId: '',
                doctorSearchText: '',
                fetchingDoctor: false,
                fetchingHospital: false,
                hospitalSearchText: '',
            });
        }
    }

    hide = () => {
        this.setState({ visible: false });
    }

    // 主医院搜索
    handleHospitalSearch = (value) => {
        this.setState({ fetchingHospital: true, hospitalSearchText: value });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryMainHospital,
            data: {
                offset: 1,
                limit: 20,
                hospitalMainName: value || '',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                this.setState({
                    hospitalMainList: datas || [],
                    fetchingHospital: false,
                });
            }
        };
        $.sendRequest(options);
    }

    // 中心名称选择框聚焦时自动触发搜索
    handleHospitalFocus = () => {
        const { hospitalSearchText } = this.state;
        if (!this.state.hospitalMainList.length) {
            this.handleHospitalSearch(hospitalSearchText);
        }
    }

    // 选择主医院
    handleHospitalSelect = (value, option) => {
        const { hospitalMainList } = this.state;
        const selectedValue = option.props.value;
        const pendingType = option.props.dataPendingType;
        // 从数据源中查找正确的医院名称（避免取到 children 中附带的 "(已合作)/(待合作)" 后缀）
        const selectedItem = (hospitalMainList || []).find(item =>
            (item.hospitalMainId || item.hospitalMainName) === selectedValue
        );
        const hospitalMainId = selectedValue;
        const hospitalMainName = selectedItem ? selectedItem.hospitalMainName : '';
        this.setState({
            hospitalMainId,
            hospitalMainName,
            pendingType,
            resolvedHospitalId: '',
            courtyardAreaList: [],
            courtyardArea: '',
            departmentList: [],
            departmentId: '',
            doctorList: [],
            doctorId: '',
        }, () => {
            if (pendingType === 'COOPERATING') {
                this.queryCooperatingCourtyardArea();
            } else if (pendingType === 'PENDING') {
                this.queryPendingCourtyardArea();
            }
        });
    }

    // 查询已合作院区
    queryCooperatingCourtyardArea = () => {
        const { hospitalMainId } = this.state;
        if (!hospitalMainId) return;
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryHospitalCourtyardAreaList,
            data: { hospitalMainId },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                const list = datas || [];
                this.setState({ courtyardAreaList: list });
                // 只有一个院区时自动默认选中（直接设置院区信息，不调handleCourtyardSelect以免重置科室/医生）
                if (list.length === 1) {
                    const item = list[0];
                    const val = item.courtyardArea || '';
                    const resolvedId = item.hospitalId || '';
                    this.setState({
                        courtyardArea: val,
                        resolvedHospitalId: resolvedId,
                    }, () => {
                        if (resolvedId) {
                            this.queryDepartments('');
                        }
                    });
                }
            }
        };
        $.sendRequest(options);
    }

    // 查询待合作院区
    queryPendingCourtyardArea = () => {
        const { hospitalMainName } = this.state;
        if (!hospitalMainName) return;
        const options = {
            method: 'POST',
            url: API_URL.hospital.pendingCooperationCourtyardListForAdd,
            data: { equHospitalName: hospitalMainName },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                const list = datas || [];
                this.setState({ courtyardAreaList: list });
                // 只有一个院区时自动默认选中（直接设置院区信息，不调handleCourtyardSelect以免重置科室/医生）
                if (list.length === 1) {
                    const item = list[0];
                    const val = item.courtyardArea || '';
                    const resolvedId = item.hospitalPendingCooperationId || '';
                    this.setState({
                        courtyardArea: val,
                        resolvedHospitalId: resolvedId,
                    }, () => {
                        if (resolvedId) {
                            this.queryDepartments('');
                        }
                    });
                }
            }
        };
        $.sendRequest(options);
    }

    // 选择院区（此时获取实际ID：COOPERATING取hospitalId，PENDING取hospitalPendingCooperationId）
    handleCourtyardSelect = (value) => {
        const { pendingType, courtyardAreaList } = this.state;
        let resolvedHospitalId = '';
        // 根据 courtyardArea 匹配选中项
        // 当 value 为空但列表仅有一条记录时，自动选中该条（处理 courtyardArea 为 null 的场景）
        let selected = null;
        if (value !== null && value !== undefined) {
            selected = (courtyardAreaList || []).find(item =>
                item.courtyardArea === value
            );
        }
        if (!selected && courtyardAreaList && courtyardAreaList.length === 1) {
            selected = courtyardAreaList[0];
            value = selected.courtyardArea || '';
        }
        if (selected) {
            resolvedHospitalId = pendingType === 'COOPERATING'
                ? (selected.hospitalId || '')
                : (selected.hospitalPendingCooperationId || '');
        }
        this.setState({
            courtyardArea: value,
            resolvedHospitalId,
            departmentList: [],
            departmentId: '',
            doctorList: [],
            doctorId: '',
        }, () => {
            if (resolvedHospitalId) {
                this.queryDepartments('');
            }
        });
    }

    // 科室选择框聚焦时自动查询科室数据
    handleDepartmentFocus = () => {
        const { resolvedHospitalId, departmentList } = this.state;
        if (resolvedHospitalId && !departmentList.length) {
            this.queryDepartments('');
        }
    }

    // 查询科室
    queryDepartments = (searchText) => {
        const { pendingType, hospitalMainId, resolvedHospitalId, hospitalMainName } = this.state;
        const deptName = searchText || '';
        if (pendingType === 'COOPERATING') {
            if (!resolvedHospitalId) return;
            const options = {
                method: 'POST',
                url: API_URL.hospital.queryDepWhenAddDoctor,
                data: {
                    limit: 999,
                    hospitalId: resolvedHospitalId,
                    hospitalDepName: deptName,
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    const departmentList = (datas || []).map(item => ({
                        ...item,
                        deptName: item.departmentLocalName || item.deptName,
                    }));
                    this.setState({ departmentList, fetchingDepartment: false });
                },
                failResult: () => this.setState({ fetchingDepartment: false }),
            };
            $.sendRequest(options);
        } else if (pendingType === 'PENDING') {
            // 待合作科室：使用resolvedHospitalId（即hospitalPendingCooperationId）查询，支持科室名称模糊搜索
            if (!resolvedHospitalId) return;
            const options = {
                method: 'POST',
                url: API_URL.hospital.deptPendingCooperationListByHospitalId,
                data: {
                    hospitalId: resolvedHospitalId,
                    deptName: deptName || '',
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    this.setState({ departmentList: datas || [], fetchingDepartment: false });
                },
                failResult: () => this.setState({ fetchingDepartment: false }),
            };
            $.sendRequest(options);
        }
    }

    // 选择科室
    handleDepartmentSelect = (value) => {
        this.setState({
            departmentId: value,
            departmentSearchText: '',
            doctorList: [],
            doctorId: '',
            doctorSearchText: '',
            fetchingDoctor: true,
        }, () => {
            this.queryDoctors();
        });
    }

    // 科室搜索
    handleDepartmentSearch = (value) => {
        this.setState({ departmentSearchText: value, fetchingDepartment: true });
        this.queryDepartments(value);
    }

    // 查询医生
    queryDoctors = () => {
        const { pendingType, resolvedHospitalId, departmentId } = this.state;
        if (!departmentId) return;
        if (pendingType === 'COOPERATING') {
            const options = {
                method: 'POST',
                url: API_URL.hospital.queryDoctorForAdd,
                data: {
                    hospitalId: resolvedHospitalId,
                    hospitalDepartmentId: departmentId,
                    limit: 999,
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    this.setState({ doctorList: datas || [], fetchingDoctor: false });
                }
            };
            $.sendRequest(options);
        } else if (pendingType === 'PENDING') {
            const options = {
                method: 'POST',
                url: API_URL.hospital.doctorPendingCooperationList,
                data: {
                    hospitalDepartmentId: departmentId,
                    offset: 1,
                    limit: 999,
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    this.setState({ doctorList: datas || [], fetchingDoctor: false });
                }
            };
            $.sendRequest(options);
        }
    }

    // 选择医生
    handleDoctorSelect = (value) => {
        this.setState({ doctorId: value });
    }

    // 提交
    submit = () => {
        const { isEdit, evaluateRecordSiteId, evaluateRecordId,
                pendingType, resolvedHospitalId, departmentId, doctorId,
                hospitalMainName } = this.state;

        if (!hospitalMainName) {
            return message.warning('请选择中心名称');
        }
        if (!resolvedHospitalId) {
            return message.warning('请选择院区');
        }
        if (!departmentId) {
            return message.warning('请选择科室');
        }

        this.setState({ loading: true });

        // 无论COOPERATING还是PENDING，都使用hospitalId/hospitalDepartmentId/doctorPostId参数
        // Manager根据pendingType自动转换到pending字段或保持原样
        const data = {
            evaluateRecordId,
            pendingType,
            hospitalId: resolvedHospitalId,
            hospitalDepartmentId: departmentId,
            doctorPostId: doctorId || null,
        };

        if (isEdit) {
            data.evaluateRecordSiteId = evaluateRecordSiteId;
        }

        const url = isEdit ? API_URL.evaluate.updateEvaluateRecordSite : API_URL.evaluate.addEvaluateRecordSite;

        const options = {
            method: 'POST',
            url,
            data,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false });
                this.hide();
                this.props.loadData();
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
            failResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, loading, isEdit, hospitalMainList, hospitalMainName,
                fetchingHospital, pendingType, courtyardAreaList, courtyardArea,
                departmentList, departmentId, fetchingDepartment,
                doctorList, doctorId, fetchingDoctor } = this.state;

        return (
            <Modal
                title={isEdit ? '修改关联中心' : '新增关联中心'}
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                confirmLoading={loading}
                width="600px"
                footer={
                    <span>
                        <Button onClick={this.hide} style={{ marginRight: 8 }}>取消</Button>
                        <Button type="primary" onClick={this.submit} loading={loading}>确定</Button>
                    </span>
                }
            >
                <div className="modal-content" style={{ padding: '10px 30px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '30%' }}>
                                <span style={{ color: 'red' }}>*</span>中心名称：
                            </div>
                            <div className="item-right" style={{ width: '70%' }}>
                                <Select
                                    showSearch
                                    value={hospitalMainName || undefined}
                                    placeholder="请输入中心名称搜索"
                                    style={{ width: '100%' }}
                                    defaultActiveFirstOption={false}
                                    showArrow={false}
                                    filterOption={false}
                                    onSearch={this.handleHospitalSearch}
                                    onFocus={this.handleHospitalFocus}
                                    onSelect={this.handleHospitalSelect}
                                    notFoundContent={fetchingHospital ? <Spin size="small" /> : null}
                                >
                                    {
                                        (hospitalMainList || []).map(item => (
                                            <Option
                                                key={item.hospitalMainId || item.hospitalMainName}
                                                value={item.hospitalMainId || item.hospitalMainName}
                                                dataPendingType={item.pendingType}
                                            >
                                                {item.hospitalMainName} ({item.pendingType === 'COOPERATING' ? '已合作' : '待合作'})
                                            </Option>
                                        ))
                                    }
                                </Select>
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '30%' }}><span style={{ color: 'red' }}>*</span>中心院区：</div>
                            <div className="item-right" style={{ width: '70%' }}>
                                <Select
                                    value={courtyardArea != null ? courtyardArea : undefined}
                                    placeholder="请选择院区"
                                    style={{ width: '100%' }}
                                    allowClear={courtyardAreaList.length > 1}
                                    disabled={courtyardAreaList.length === 1}
                                    onChange={this.handleCourtyardSelect}
                                >
                                    {
                                        (courtyardAreaList || []).map((item, idx) => (
                                            <Option
                                                key={item.courtyardArea || `area_${idx}`}
                                                value={item.courtyardArea || ''}
                                            >
                                                {item.courtyardArea || ''}
                                            </Option>
                                        ))
                                    }
                                </Select>
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '30%' }}>
                                <span style={{ color: 'red' }}>*</span>中心科室：
                            </div>
                            <div className="item-right" style={{ width: '70%' }}>
                                <Select
                                    showSearch
                                    value={departmentId || undefined}
                                    placeholder="请选择科室（可输入检索）"
                                    style={{ width: '100%' }}
                                    defaultActiveFirstOption={false}
                                    showArrow
                                    filterOption={false}
                                    onSearch={this.handleDepartmentSearch}
                                    onFocus={this.handleDepartmentFocus}
                                    onChange={this.handleDepartmentSelect}
                                    notFoundContent={fetchingDepartment ? <Spin size="small" /> : null}
                                >
                                    {
                                        (departmentList || []).map(item => (
                                            <Option
                                                key={item.hospitalDepartmentId || item.hospitalDeptPendingCooperationId}
                                                value={item.hospitalDepartmentId || item.hospitalDeptPendingCooperationId}
                                            >
                                                {item.deptName}
                                            </Option>
                                        ))
                                    }
                                </Select>
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '30%' }}>PI：</div>
                            <div className="item-right" style={{ width: '70%' }}>
                                <Select
                                    showSearch
                                    value={doctorId || undefined}
                                    placeholder="请选择PI（可输入检索）"
                                    style={{ width: '100%' }}
                                    defaultActiveFirstOption={false}
                                    showArrow
                                    allowClear
                                    filterOption={(input, option) =>
                                        (option.props.children || '').toLowerCase().indexOf((input || '').toLowerCase()) >= 0
                                    }
                                    onChange={this.handleDoctorSelect}
                                    notFoundContent={fetchingDoctor ? <Spin size="small" /> : null}
                                >
                                    {
                                        (doctorList || []).map(item => (
                                            <Option
                                                key={item.doctorPostId || item.doctorPendingCooperationId || item.userId}
                                                value={item.doctorPostId || item.doctorPendingCooperationId || item.userId}
                                            >
                                                {item.userCompellation || item.doctorName}
                                            </Option>
                                        ))
                                    }
                                </Select>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default EvaluateSiteUpdate;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/EvaluateSiteUpdate.js